import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const Students = lazy(() => import('../pages/StudentsPage'));
const StudentFormPage = lazy(() => import('../pages/StudentFormPage'));
const StudentProfilePage = lazy(() => import('../pages/StudentProfilePage'));

const StudentRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Students />} />
      <Route path="add" element={<StudentFormPage />} />
      <Route path="edit/:id" element={<StudentFormPage />} />
      <Route path=":id" element={<StudentProfilePage />} />
    </Routes>
  );
};

export default StudentRoutes;
